export default defineNuxtRouteMiddleware(async (nuxt) => {
  const isValidUrl = nuxt.params.type === localStorage.getItem("courseType");

  if (!isValidUrl) {
    useBelajarWajibStore().clearTokens();
    return navigateTo({ path: "/pembelajaran-wajib/login" });
  }
  if (localStorage.getItem("toggleList")) {
    useBelajarWajibStore().$patch((state) => {
      state.toggleList = JSON.parse(localStorage.getItem("toggleList")) || {};
    });
  }
  if (localStorage.getItem("dataPegawai")) {
    useBelajarWajibStore().$patch((state) => {
      state.dataPegawai = JSON.parse(localStorage.getItem("dataPegawai")) || {};
    });
  }
  if (localStorage.getItem("profile")) {
    useBelajarWajibStore().$patch((state) => {
      state.profile = JSON.parse(localStorage.getItem("profile")) || {};
    });
  }
  if (localStorage.getItem("courseList")) {
    useBelajarWajibReaderStore().$patch((state) => {
      state.courseList = JSON.parse(localStorage.getItem("courseList")) || [];
    });
  }

  const dataPegawai = JSON.parse(localStorage.getItem("dataPegawai")) || {};
  if (dataPegawai.statusPegawai === "PPPK")
    return navigateTo("/portal-pembelajaran");
});
